import { FC } from "react";
import styles from "./DownloadApp.module.scss";

import DesktopView from "./DownloadAppDesktop";

const DownloadApp: FC = () => {
  return (
    <section className={styles.downloadAppWrapper}>
      <DesktopView />
    </section>
  );
};

export default DownloadApp;
